// extracted by mini-css-extract-plugin
module.exports = {"tab":"QzeucK","scrollable":"Y+mTFw"};